// Takes a list of tickets from outbound/inboundTickets from the Trips array, and only returns unique fareKeys. This is needed as the list of fares can have duplicated fareKeys in the list, and there's no point in showing the same ticket type multiple times to the user.
export function getUniqueListOfTickets(ticketsList) {
    const data = ticketsList;
    const key = "fareKey"; // The key to check for uniqueness

    const map = new Map();
    data.forEach((item) => {
        // Only set the item if the key doesn't exist yet in the map
        if (!map.has(item[key])) {
            map.set(item[key], item);
        }
    });

    // Convert the map values back to an array
    const uniqueData = Array.from(map.values());

    return uniqueData;
}
